import React from 'react';
import { View, Image, TouchableWithoutFeedback } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import styles from '../styles';
import { AppText } from '../../../components/form';
import splash_03 from '../../../assets/images/splash_03.jpg';
import logo_purple from '../../../assets/images/logo_purple.png';

const WelcomeThree = ({ navigation }) => {
  const navigateTo = (site) => navigation.navigate(`Welcome ${site}`);
  const goToLogin = () => {
    navigation.navigate('Login', { screen: 'Base' });
    AsyncStorage.setItem('welcomeVisited', JSON.stringify(true));
  };
  return (
    <TouchableWithoutFeedback onPress={goToLogin}>
      <View style={styles.viewBase}>
        <View style={styles.viewLogo}>
          <Image style={styles.imageLogo} source={logo_purple} />
        </View>
        <View style={styles.lineBlue}>
          <View style={styles.lineCyan}>
            <Image style={styles.imageSplash} source={splash_03} />
          </View>
        </View>
        <View style={styles.card}>
          <AppText style={[styles.textWelcome, styles.textSmaller]}>{'UMA PLATAFORMA\nCOMPLETA DE GINÁSTICA\nLABORAL ONLINE!'}</AppText>
          <View style={styles.viewBallContainer}>
            <View style={styles.viewBall} />
            <View style={styles.viewBall} />
            <View style={[styles.viewBall, styles.viewBallOrange]} />
          </View>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

export default WelcomeThree;
